export class PatientSyncMeasurerStruct {
    public idPatientSyncMeasurer: number | null = null;
    public idSyncMeasurer: number | null = null;
    public idPatient: number | null = null;
    public otherComorbidity: string = '';
    public otherMedicine: string = '';
    public isDeleted: boolean = false;
}